import {
   START_FETCH_HABITS, 
   ERROR_FETCH_HABITS,
   DONE_FETCH_HABITS, 
   START_SAVING_HABIT, 
   ERROR_SAVING_HABIT, 
   DONE_SAVING_HABIT,
   START_MARKING_COMPLETE, 
   ERROR_MARKING_COMPLETE, 
   DONE_MARKING_COMPLETE,
   START_FETCH_CHECKLISTS,
   ERROR_FETCH_CHECKLISTS,
   DONE_FETCH_CHECKLISTS,
   START_UNDO_COMPLETE,
   ERROR_UNDO_COMPLETE,
   DONE_UNDO_COMPLETE,
   START_DELETE_HABIT,
   ERROR_DELETE_HABIT,
   DONE_DELETE_HABIT,
} from "./constants";

const initialState = {
  fetchHabits: {
     status: 'IDLE',
     message: ''
  }, 
  savingHabit: {},
  deletingHabit: {},
  markingComplete: {},
  fetchingChecklists: {},
  undoComplete: {}
}

export default function requestReducer(state = initialState, action){

  const update = function (state, subState, status, message = ''){
    return  {...state, [subState]: {...state[subState], status, message}};
  }

  const updateSavingHabit = function(state, habitUUID, status, message = ''){
    return {...state, savingHabit: {...state.savingHabit, [habitUUID]: {...state.savingHabit[habitUUID], status, message}}}
  }

  const updateDeleteHabit = function(state, habitID, status, message = ''){
    return {...state, deletingHabit: {...state.deletingHabit, [habitID]: {...state.deletingHabit[habitID], status, message}}}
  }

  const updateMarkingComplete = function(state, habitID, date, status){
    return {
      ...state, 
      markingComplete: {
        ...state.markingComplete, 
        [habitID]: {
          ...state.markingComplete[habitID], 
          [date.setHours(0,0,0,0)]: status
        }
      }
    }  
  }

  const updateUndoComplete = function(state, habitID, date, status){
    return {
      ...state, 
      undoComplete: {
        ...state.undoComplete, 
        [habitID]: {
          ...state.undoComplete[habitID], 
          [date.setHours(0,0,0,0)]: status
        }
      }
    }  
  }
  
  switch(action.type){

    case START_FETCH_HABITS:
      return update(state, 'fetchHabits', 'FETCHING')

    case ERROR_FETCH_HABITS:
      return update(state, 'fetchHabits', 'ERROR');

    case DONE_FETCH_HABITS:
      return update(state, 'fetchHabits', 'IDLE');

    case START_SAVING_HABIT:
      return updateSavingHabit(state, action.habit.uuid, 'SAVING');

    case ERROR_SAVING_HABIT:
      return updateSavingHabit(state, action.habit.uuid, 'ERROR');
      
    case DONE_SAVING_HABIT:
      return updateSavingHabit(state, action.habit.uuid, 'IDLE');

    case START_DELETE_HABIT:
      return updateDeleteHabit(state, action.habit.id, 'PROCESSING');

    case ERROR_DELETE_HABIT:
      return updateDeleteHabit(state, action.habit.id, 'ERROR');

    case DONE_DELETE_HABIT:
      return updateDeleteHabit(state, action.habit.id, 'IDLE');

    case START_MARKING_COMPLETE:
      return updateMarkingComplete(state, action.habit.id, action.date, 'PROCESSING');

    case ERROR_MARKING_COMPLETE:
      return updateMarkingComplete(state, action.habit.id, action.date, 'ERROR');

    case DONE_MARKING_COMPLETE: 
      return updateMarkingComplete(state, action.habit.id, action.date, 'IDLE');

    case START_FETCH_CHECKLISTS:
      return update(state, 'fetchingChecklists', 'FETCHING');

    case ERROR_FETCH_CHECKLISTS:
      return update(state, 'fetchingChecklists', 'ERROR');

    case DONE_FETCH_CHECKLISTS:
      return update(state, 'fetchingChecklists', 'IDLE');

    case START_UNDO_COMPLETE:
      return updateUndoComplete(state, action.habit.id, action.date, 'PROCESSING');

    case ERROR_UNDO_COMPLETE:
      return updateUndoComplete(state, action.habit.id, action.date, 'ERROR');

    case DONE_UNDO_COMPLETE:
      return updateUndoComplete(state, action.habit.id, action.date, 'IDLE');

    default:
      return state;

  }

  return state;
}
